export const RXRLOGO = () => {
  return (
    <svg
      width="92px"
      height="33px"
      viewBox="0 0 92 33"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>LOGO / WHITE</title>
      <desc>Created with Sketch.</desc>
      <g
        id="_Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="NAVIGATION-/-NAV-DESKTOP-/-ON-LIGHT-/-2.-OUR-PORTFOLIO"
          transform="translate(-30.000000, -46.000000)"
          fill="#03001A"
        >
          <g id="LOGO-/-BLACK" transform="translate(30.000000, 39.000000)">
            <path
              d="M66.9206957,21.6821175 L77.7524712,21.6821175 C82.2198137,21.6821175 85.3414457,20.495579 85.3414457,16.3775923 C85.3414457,12.329402 82.2198137,11.0730671 77.7524712,11.0730671 L66.9206957,11.0730671 L66.9206957,21.6821175 Z M62.1473709,7.44365512 L78.4868289,7.44365512 C84.1781008,7.44365512 90.1141585,9.32815749 90.1141585,16.3077959 C90.1141585,20.2861898 88.0334785,24.0551945 81.7302419,24.9625475 L91.7052668,38.3634533 L85.891602,38.3634533 L76.1619749,25.2417331 L66.9206957,25.2417331 L66.9206957,38.3634533 L62.1473709,38.3634533 L62.1473709,7.44365512 Z"
              id="Fill-6"
            ></path>
            <path
              d="M31.5789486,7.15736069 L45.0786377,20.1353474 L45.0786377,26.2436559 L31.5789486,39.2223366 L31.5789486,33.0453174 L42.0718888,23.1891546 L31.5789486,13.3343799 L31.5789486,7.15736069 Z M59.621055,7.15736069 L59.621055,13.3343799 L49.1287285,23.1891546 L59.621055,33.0453174 L59.621055,39.2223366 L46.1213659,26.2436559 L46.1213659,20.1353474 L59.621055,7.15736069 Z"
              id="Combined-Shape"
            ></path>
            <path
              d="M4.77332481,21.6821175 L15.6051003,21.6821175 C20.0724428,21.6821175 23.1934628,20.495579 23.1934628,16.3775923 C23.1934628,12.329402 20.0724428,11.0730671 15.6051003,11.0730671 L4.77332481,11.0730671 L4.77332481,21.6821175 Z M0,7.44365512 L16.339458,7.44365512 C22.0307299,7.44365512 27.9667876,9.32815749 27.9667876,16.3077959 C27.9667876,20.2861898 25.8861076,24.0551945 19.582871,24.9625475 L29.5578959,38.3634533 L23.7442311,38.3634533 L14.0139921,25.2417331 L4.77332481,25.2417331 L4.77332481,38.3634533 L0,38.3634533 L0,7.44365512 Z"
              id="Fill-3"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};
